import LandingScreen from "../screen/LandingScreen";
import WhoWeAreScreen from "../screen/WhoWeAreScreen";
import ContactUsScreen from "../screen/ContactUsScreen";
import IdentityScreen from "../screen/business/IdentityScreen";
import CloudScreen from "../screen/business/CloudScreen";
import FintechScreen from "../screen/business/FintechScreen";
import AuthenticationScreen from "../screen/business/AuthenticationScreen";
import DigitalInfrastructureScreen from "../screen/business/DigitalInfrastructureScreen";
import BusinessesScreen from "../screen/BusinessesScreen";
import NewsAndUpdatesScreen from "../screen/NewsAndUpdatesScreen";
import BlogPostScreen from "../screen/BlogPostScreen";

export const routes = [
    {
        path: "/",
        name: "LandingScreen",
        element: <LandingScreen />,
        isPrivate: false
    },

    {
        path: "/who-we-are",
        name: "WhoWeAreScreen",
        element: <WhoWeAreScreen />,
        isPrivate: false
    },

    {
        path: "/contact-us",
        name: "ContactUsScreen",
        element: <ContactUsScreen />,
        isPrivate: false
    },

    // Business Routes
    {
        path: "/business-identity",
        name: "IdentityScreen",
        element: <IdentityScreen />,
        isPrivate: false
    },
    {
        path: "/business-cloud",
        name: "CloudScreen",
        element: <CloudScreen />,
        isPrivate: false
    },
    {
        path: "/business-fintech",
        name: "FintechScreen",
        element: <FintechScreen />,
        isPrivate: false
    },
    {
        path: "/business-authentication",
        name: "AuthenticationScreen",
        element: <AuthenticationScreen />,
        isPrivate: false
    },
    {
        path: "/business-digital-infrastructure",
        name: "DigitalInfrastructureScreen",
        element: <DigitalInfrastructureScreen />,
        isPrivate: false
    },
    {
        path: "/businesses",
        name: "BusinessesScreen",
        element: <BusinessesScreen />,
        isPrivate: false
    },

    // Blog Routes
    {
        path: "/news-and-updates",
        name: "NewsAndUpdatesScreen",
        element: <NewsAndUpdatesScreen />,
        isPrivate: false
    },
    {
        path: "/news-and-updates/:slug",
        name: "BlogPostScreen",
        element: <BlogPostScreen />,
        isPrivate: false
    }
]
